<!--
* @description:
* @fileName notice.vue
* @author hvv
* @date 2022/01/14 10:37:18
!-->
<template>
  <div></div>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  export default defineComponent({
    name: 'Notice',
    setup() {},
  })
</script>
<style lang="scss" scoped></style>
